import React from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { FiImage } from 'react-icons/fi';

const ImagePicker = ({
    preloadedImage,
    onImageSelect,
    placeholder = "Click to upload image",
    acceptedFormats = ".jpg,.png,.jpeg",
    maxFileSize = 10,
    disabled = false,
    needCoverImage = false,
}) => {
    const handleImageSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size > maxFileSize * 1024 * 1024) {
                alert(`File size exceeds ${maxFileSize}MB limit`);
                return;
            }
            onImageSelect(file);
        }
    };

    return (
        <div className={`relative w-full h-full border-2 border-dashed rounded-lg transition-all duration-200 
            ${disabled ? 'border-gray-300 bg-gray-100' : 'border-gray-400 hover:border-primary hover:bg-primary/5'}`}>

            {preloadedImage ? (
                <div className="relative w-full h-full">
                    <img
                        src={typeof preloadedImage === 'string' ? preloadedImage : URL.createObjectURL(preloadedImage)}
                        alt="Selected"
                        className={`w-full h-full ${needCoverImage ? "object-cover" : "object-contain"} rounded-md`}
                    />
                    {!disabled && (
                        <div className="absolute inset-0 bg-black/30 opacity-0 hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                            <FiImage className="text-white text-2xl" />
                            <span className="text-white ml-2 font-medium">Change Image</span>
                        </div>
                    )}
                </div>
            ) : (
                <div className="flex flex-col items-center justify-center p-6 h-full w-full">
                    <div className={`p-4 rounded-full mb-3 ${disabled ? 'bg-gray-200' : 'bg-primary/10'}`}>
                        <FaCloudArrowUp size={24} className={disabled ? 'text-gray-400' : 'text-primary'} />
                    </div>
                    <p className={`font-medium ${disabled ? 'text-gray-500' : 'text-gray-700'}`}>
                        {placeholder}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                        Supported: {acceptedFormats.replace(/,/g, ", ")} (max {maxFileSize}MB)
                    </p>
                </div>
            )}

            {!disabled && (
                <label className="absolute inset-0 cursor-pointer">
                    <input
                        type="file"
                        className="hidden"
                        accept={acceptedFormats}
                        onChange={handleImageSelect}
                        disabled={disabled}
                    />
                </label>
            )}
        </div>
    );
};

export default ImagePicker;